import LayoutDefault from '../../page/LayoutDefault'

export default LayoutDefault
